import React from 'react';
import { useAppContext, ACTIONS } from '../context/AppContext';
import { ReactComponent as GetTalkyLogo } from '../Get Talky Icon Logo SVG.svg';

const TranscriptPanel = ({ style }) => {
  const { state, dispatch } = useAppContext();
  const { currentInteraction } = state;
  const transcript = currentInteraction?.transcript || [];

  return (
     <div 
      style={style}
      className="fixed z-40 bg-white rounded-lg shadow-2xl w-[400px] h-[600px] flex flex-col"
    >
       <div className="flex items-center justify-between p-4 border-b bg-gray-50 rounded-t-lg flex-shrink-0">
        <h3 className="text-lg font-semibold text-gray-800">Call Transcript</h3>
        <button onClick={() => dispatch({ type: ACTIONS.TOGGLE_TRANSCRIPT })} className="p-1 rounded-full hover:bg-gray-200">
           <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
           </svg>
         </button>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-4 min-h-0">
        {transcript.map((item, index) => (
          <div key={index} className={`flex items-start gap-3 ${item.speaker === 'User' ? 'justify-start' : 'flex-row-reverse'}`}>
            <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${item.speaker === 'User' ? 'bg-gray-300' : 'bg-blue-500'}`}>
              {item.speaker === 'AI' && <GetTalkyLogo style={{ width: 20, height: 20, fill: 'white' }} />}
            </div>
            <div className={`p-3 rounded-lg max-w-xs ${item.speaker === 'User' ? 'bg-gray-100 text-gray-800' : 'bg-blue-100 text-blue-900'}`}>
              <p className="font-bold text-sm">{item.speaker}</p>
              <p className="text-sm">{item.text}</p>
            </div>
          </div>
        ))}
        {transcript.length === 0 && <p className="text-center text-gray-500">No transcript available.</p>}
      </div>
    </div>
  );
};

export default TranscriptPanel; 